module.exports = __webpack_public_path__ + "img/i_h_like_off_big.de22401c.svg";